<dx-popup
    #manualCreditApplicationEditorBox
    width="70%"
    height="90%"
    [title]="popUpTitle"
    [showTitle]="true"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let item of 'content'" class="manual-credit-application-editor-content">
        <dx-box width="100%" height="100%" direction="col" *ngIf="!!editorResult && !!editorResult.source">
            <dxi-item baseSize="auto">
                <strong class="source-transactions-title">AR {{ editorResult.source.documentType }}</strong>

                <dx-form
                    #sourceTransactionForm
                    width="100%"
                    height="100%"
                    [colCount]="3"
                    [labelLocation]="defaultLabelLocation"
                >
                    <dxi-item>
                        <dxo-label text="Sub Ledger"></dxo-label>
                        <div *dxTemplate>
                            {{ editorResult.source.subLedgerTitle }}
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Document Type"></dxo-label>
                        <div *dxTemplate>
                            {{ editorResult.source.documentType }}
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Document Number"></dxo-label>
                        <div *dxTemplate>
                            {{ editorResult.source.documentNumber }}
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Amount"></dxo-label>
                        <div *dxTemplate>
                            {{ editorResult.source.amount | ccCurrency }}
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Unapplied Amount"></dxo-label>
                        <div *dxTemplate>
                            {{ editorResult.source.unappliedAmount | ccCurrency }}
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Doc Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box
                                [width]="100"
                                [(value)]="editorResult.source.documentDate"
                                type="date"
                                [readOnly]="true"
                                [displayFormat]="dateFormat"
                            ></dx-date-box>
                        </div>
                    </dxi-item>

                    <dxi-item [colSpan]="2">
                        <dxo-label text="Dimensions"></dxo-label>
                        <div *dxTemplate>
                            <div [innerHTML]="getSourceDimensionText()"></div>
                        </div>
                    </dxi-item>

                    <dxi-item isRequired="true">
                        <dxo-label text="Apply Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box
                                type="date"
                                [width]="100"
                                [min]="minApplyDate"
                                [(value)]="applyDate"
                            ></dx-date-box>
                        </div>
                    </dxi-item>

                    <dxi-item [colSpan]="3" *ngIf="creditApplicationSourceLineItems.length > 1">
                        <div *dxTemplate>
                            <ng-container *ngIf="totalAppliedAmount > 0">
                                <div
                                    *ngFor="let line of creditApplicationSourceLineItems; let i = index"
                                    class="text-communication-history-container unapplied-amount-line"
                                >
                                    Remaining Unapplied Amount Line {{ i }}: {{ line.remainingUnapplied | ccCurrency }}
                                </div>
                            </ng-container>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="3" itemType="empty"></dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item [ratio]="1">
                <strong>Target Transactions</strong>
                <dx-data-grid
                    #targetGrid
                    class="cc-vertical-center-cell-data-grid"
                    width="100%"
                    height="90%"
                    [dataSource]="editorResult.targets"
                    [allowColumnReordering]="true"
                    [allowColumnResizing]="true"
                    [columnAutoWidth]="true"
                    [showBorders]="true"
                    [showColumnLines]="true"
                    [showRowLines]="true"
                    noDataText="No data to display"
                >
                    <dxi-column
                        dataField="isSelect"
                        caption="Select"
                        alignment="center"
                        cellTemplate="selectTemplate"
                    ></dxi-column>
                    <dxi-column
                        dataField="appliedAmount"
                        caption="Apply Amount"
                        dataType="number"
                        cellTemplate="applyAmountTemplate"
                        [width]="90"
                        [format]="currencyFormat"
                    ></dxi-column>
                    <dxi-column dataField="documentType" caption="Document Type" dataType="string"></dxi-column>
                    <dxi-column dataField="documentNumber" caption="Document Number" dataType="string"></dxi-column>
                    <dxi-column
                        dataField="amount"
                        caption="Amount"
                        dataType="number"
                        [format]="currencyFormat"
                    ></dxi-column>
                    <dxi-column
                        dataField="openBalance"
                        caption="Open Balance"
                        dataType="number"
                        [format]="currencyFormat"
                    ></dxi-column>
                    <dxi-column
                        dataField="documentDate"
                        caption="Doc Date"
                        dataType="date"
                        [format]="dateFormat"
                    ></dxi-column>
                    <dxi-column
                        dataField="postDate"
                        caption="Post Date"
                        dataType="date"
                        [format]="dateFormat"
                    ></dxi-column>
                    <dxi-column
                        dataField="lineItems"
                        caption="Dimensions"
                        dataType="string"
                        cellTemplate="dimensionTemplate"
                    ></dxi-column>
                    <dxi-column dataField="subLedgerTitle" caption="Sub Ledger" dataType="string"></dxi-column>

                    <div *dxTemplate="let row of 'applyAmountTemplate'">
                        <dx-number-box
                            [format]="currencyFormat"
                            [(value)]="row.value"
                            [readOnly]="!row.data.isAmountEditable"
                            (onFocusIn)="applyAmountFocus(row.data)"
                            (onValueChanged)="onApplyAmountValueChanged($event, row.data)"
                        ></dx-number-box>
                    </div>

                    <div *dxTemplate="let row of 'dimensionTemplate'">
                        <div [innerHTML]="getTargetDimensionText(row.data)"></div>
                    </div>

                    <div *dxTemplate="let row of 'selectTemplate'">
                        <dx-check-box
                            [(value)]="row.data.isSelect"
                            (onValueChanged)="onRowSelect($event, row.data)"
                        ></dx-check-box>
                    </div>

                    <dxo-header-filter [visible]="false"></dxo-header-filter>
                    <dxo-filter-panel [visible]="false"></dxo-filter-panel>
                    <dxo-group-panel [visible]="false"></dxo-group-panel>
                    <dxo-sorting mode="none"></dxo-sorting>
                    <dxo-scrolling mode="standard"></dxo-scrolling>
                    <dxo-load-panel [enabled]="false"></dxo-load-panel>
                </dx-data-grid>
            </dxi-item>
            <dxi-item baseSize="auto" class="target-transaction">
                <dx-form width="100%" height="100%" [colCount]="3" [labelLocation]="defaultLabelLocation">
                    <dxi-item>
                        <dxo-label text="Total Applied"></dxo-label>
                        <div *dxTemplate>
                            {{ totalAppliedAmount | ccCurrency }}
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Remaining Unapplied"></dxo-label>
                        <div *dxTemplate>
                            {{ remainingUnappliedAmount | ccCurrency }}
                        </div>
                    </dxi-item>
                    <dxi-item itemType="empty"></dxi-item>
                    <dxi-item [colSpan]="3">
                        <div *dxTemplate>
                            <dx-toolbar width="100%">
                                <dxi-item location="after">
                                    <div *dxTemplate>
                                        <dx-button
                                            type="success"
                                            [icon]="iconCheck"
                                            [disabled]="
                                                editorResult.targets.length === 0 ||
                                                !applyDate ||
                                                totalAppliedAmount === 0
                                            "
                                            text="Apply"
                                            (onClick)="onApplyClick()"
                                        ></dx-button>
                                    </div>
                                </dxi-item>

                                <dxi-item location="before">
                                    <div *dxTemplate>
                                        <dx-button
                                            type="default"
                                            [icon]="iconCancel"
                                            text="Cancel"
                                            (onClick)="onHidden()"
                                        ></dx-button>
                                    </div>
                                </dxi-item>
                            </dx-toolbar>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<cc-message-box #arMessageBox></cc-message-box>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#manualCreditApplicationEditorBox' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<app-ar-manual-line-item-credit-application
    *ngIf="showSpecifyApplyAmount"
    [visible]="showSpecifyApplyAmount"
    [sourceLineItemAppliedAmountsDataEntries]="creditApplicationSourceLineItems"
    [selectedTargetItem]="selectedTargetRow"
    [remainingUnappliedAmount]="remainingUnappliedAmount"
    [totalAppliedAmount]="selectedTargetRow.appliedAmount"
    (onSave)="onLineItemSaved($event)"
    (closeSpecifyApplyAmount)="closeSpecifyApplyAmount($event)"
></app-ar-manual-line-item-credit-application>
